import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HTTP_HEADER_CONTENT_TYPE, MIME_TYPE_JSON, HTTP_HEADER_AUTHORIZATION } from '../../utils/constant';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';
import { tap, retry, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private apiEndpoint = environment.apiEndpoint;
  
  constructor(
    private http: HttpClient,
  ) { }
  
  public post<T>(path, body?, apiEndpoint?, additionalHeaders?): Observable<T[] | T | any>{
    let api = apiEndpoint ? apiEndpoint : this.apiEndpoint;
    let url = new URL(path, api);
    let headers = _.assign({}, additionalHeaders, { 
      [ HTTP_HEADER_CONTENT_TYPE ]: MIME_TYPE_JSON
    });

    console.info(url.href, body);

    return this.http.post<T[] | T>(url.toString(), body, {
      headers: new HttpHeaders(headers)
    }).pipe(
      // retry(3), // retry a failed request up to 3 times
      catchError(  // then handle the error
        (err) => {
          return of(err);
        }
      )
    );;
  }

  public get<T>(path, httpParams?, apiEndpoint?, additionalHeaders?): Observable<T[] | T | any> {
    let result;
    let api = apiEndpoint ? apiEndpoint : this.apiEndpoint;
    let url = new URL(path, api);

    if(!environment.production) {
      console.log("get", url.href, httpParams);
    }

    let headers = _.assign({}, additionalHeaders, {
      [HTTP_HEADER_CONTENT_TYPE]: MIME_TYPE_JSON,
    });

    return result = this.http.get<T[] | T>(url.toString(), {
      headers: new HttpHeaders(headers),
      params: httpParams
    }).pipe(
      catchError((err) => {        
        return of(err);
      })
    );
  }
}
